import CommentService from '../Services/CommentService';
import InputTypesEnum from '../Enums/InputTypesEnum';

// Static description for the Comments entry log (see GeneralEntryLogFigma). Declares everything
// unique about the comments panel — self-fetching list (populate + convert), HTML bodies, the
// declarative meta line, the textarea add field, and the save call. The render location (Comments.js)
// supplies only the { entityTypeId, entityId, guidEntityId } context.
export default class CommentsEntryLogDescription {
  //#region List
  static title = 'Comments';
  static bodyAsHtml = true;
  static errorCode = 'CCMP15';

  static populate = (ctx) =>
    CommentService.GetCommentsByEntityTypeIdAndEntityId(ctx.entityTypeId, ctx.entityId, ctx.guidEntityId);

  static convert = (rows) => CommentService.ConvertDBItem(rows);

  static metaAttribution = {
    attributionPrefix: 'Added by',
    authorNameKey: 'CreatedByName',
    timestampKey: 'CreatedOn',
  };

  static renderBody = (comment) => comment.Message;
  //#endregion

  //#region Add
  static addField = {
    type: InputTypesEnum.TextBox2,
    initialValue: '',
    label: null,
    placeholder: 'Type here your comment...',
    isValid: (value) => value !== '',
  };

  static addEntry = (value, ctx) => CommentService.SaveComment(ctx.entityTypeId, ctx.entityId, value, ctx.guidEntityId);
  //#endregion
}
